import styled from 'styled-components';

const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  background-color: transparent;
  border-radius: 4px;
  margin: 4px;
  padding: 4px;
  text-decoration: none;
  transition-duration: 150ms;
  color: #ffffff;

  &:hover {
    transition-duration: 150ms;
    background-color: ${(props) => props.theme.colors.hover};
  }
`;

export default IconContainer;
